import React, { useState } from "react";
import { ButtonVariant } from "../button/Shared";
import { Button } from "../button/Button";
import { iconName } from "../icons/Icons";
import { TooltipTheOneWrapper } from "../TooltipTheOne";
import { basicValidation } from "../../amorg-common";



type CopyLinkButtonProps =
{
    url: string,
    variant?:ButtonVariant,
    icon?:iconName,
    toolTipContent?: React.ReactNode,
    disabled?:boolean
};

export function CopyLinkButton(props: CopyLinkButtonProps): JSX.Element {

    const [showToolTip, setShowToolTip] = useState(false)

    function handleClickCopy() {
        navigator.clipboard.writeText(props.url);
        setShowToolTip(true)
        setTimeout(() => {
            setShowToolTip(false)
        }, 2000);
    }

    const innerDisabled = props.disabled || !basicValidation.isValidUrl(props.url, false, 2000);

    let regularToolip = props.toolTipContent !== undefined ? props.toolTipContent : "Kopiér link";
    if(innerDisabled)
        regularToolip = undefined;

    return (
        <TooltipTheOneWrapper tooltipContent={showToolTip ? "Linket er kopieret" : regularToolip}>
            <Button variant={props.variant ?? "text"}
                onClick={handleClickCopy} 
                icon={props.icon ?? "interface_actions_copy"} 
                toolTipText={showToolTip ? "Linket er kopieret" : undefined} 
                disabled={innerDisabled}
            />
        </TooltipTheOneWrapper>
    )
}